module.exports = __webpack_public_path__ + "img/yingbiyi_name@3x.8b325415.png";